module.exports = __webpack_public_path__ + "static/img/login-left.1539acf4.png";